import { CustomNode } from '../../../types';
import { holdIcon } from '../../../icons';

export const holdNodeConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: holdIcon,
      defaultTitle: 'Hold until',
    };
  },
};
